import newYear from './newYear/zh-cn'
import activity from './activity/zh-cn'
export default {
  share: {
    title: '连接·生活',
    open: '打开',
    wxGuide: {
      ios: '请点击右上角的"..."按钮，选择"在Safari中打开”',
      android: '请点击右上角的"..."按钮，选择”在浏览器中打开”'
    }
  },
  xingshan: {
    home: {
      title: '中移动香港行山节',
      bg: 'static/xingshan/xingshan-bg-sc.jpg',
      subTitle: '全港动起来 向健康出发 为健康 一齐行',
      actTime: '活动日期：',
      noon: '（中午12时）',
      status: ['现正接受报名', '留意抽签结果', '查看抽签结果（抽签结果公布）', '确认报名', '期待活动', '进行中', '万步有礼活动进行中..'],
      process: ['报名日期', '截止报名', '抽签结果公布', '报名确认期', '活动日'],
      actDetail: '活动详情',
      invite: '邀请你参加中移动香港行山节',
      inviteConfirm: '12.16行山节活动报名查询',
      detail1: '「中移动香港行山节」由中国移动香港和中国香港旅行远足联会联合主办，目的是推动全港市民参与，提高市民步行及行山的健康意识，为健康，一齐行。',
      detail2: '大会举办行山节，旨在推广香港行山路径及郊野公园，如是次活动选址的山顶环回步行径和薄扶林水塘家乐径；而凤凰径、麦理浩径、卫奕信径等亦是香港著名的行山径。大会期望鼓励市民一齐行，携手发掘香港郊野公园的特色，推而广之成为香港旅游的重点。',
      detail3: '「中移动香港行山节」除了在12月16日当天举行行山活动外，更鼓励当日未能出席的市民在全港一同参与。大会鼓励市民当天以步行10000步为基础，完成万人行万步的创举，并培养每天步行的习惯。',
      route: {
        title: '行山路径',
        startPoint: '起点：山顶环回步行径',
        routeList: [{
          name: '家庭乐组：山顶环回步行径（山顶广场⇨夏力道⇨卢吉道）',
          timeLabel: '行程：',
          time: '约1小时10分',
          lengthLabel: '长度：',
          length: '约3.5公里',
          linkLabel: '详情 >',
          link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=山顶广场-夏力道-卢吉道&lang=sc&/#/xingshan/route/0'
        }, {
          name: '公开组：山顶广场⇨夏力道⇨薄扶林家乐径⇨薄扶林水塘道',
          timeLabel: '行程：',
          time: '约2小时',
          lengthLabel: '长度：',
          length: '约5.7公里',
          linkLabel: '详情 >',
          link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=山顶广场-夏力道-薄扶林家乐径-薄扶林水塘道&lang=sc&/#/xingshan/route/1'
        }]
      },
      traffic: '交通',
      trafficList: ['从中环天星码头乘搭15C号巴士，或在港铁中环站 J2出口步行至花园道山顶缆车站，再搭乘山顶缆车登山。', '从港铁香港站D出口往中环交易广场巴士总站，乘搭15号巴士。', '从港铁香港站E出口往公共运输交汇处，乘搭1号绿色小巴。'],
      food: {
        title: '景点美食',
        list: [
          {
            title: '香港杜莎夫人蜡像馆',
            img: ['static/xingshan/img/Madame Tussauds 1_l.png','static/xingshan/img/Madame Tussauds 2_l.png'],
            content: ['位于山顶凌霄阁的香港杜莎夫人蜡像馆，自2000年开幕以来，一直是香港最受欢迎的旅游景点之一，馆内集合超过100个按真人比例打造的名人蜡像，栩栩如生，他们分别展览于多个展区，包括「草间弥生艺术馆」、「功夫专区」、「韩流专区」、「乐坛巨星」、「时尚专区」、「风云人物」、「世界首影」、「魅力香江」、「体坛猛将」及「动漫游戏世界」。馆内不设围栏，让您尽情与心爱偶像或风云人物零距离接触及拍照留念。参观展区后，您更可到精品廊选购小金人奖座、限定版公仔及3D立体照等精致纪念品留念。']
          },
          {
            title: '太平山餐厅',
            img: ['static/xingshan/img/The Peak Lookout 1_l.png','static/xingshan/img/The Peak Lookout 2_l.png'],
            content: ['太平山餐厅座落于景色优美的太平山顶地段，原名山顶餐厅，为全亚洲最历史悠久的建筑物之一，亦被列为香港二级历史建筑。19世纪末，该建筑原为兴建山顶缆车的英国工程师提供工作和休憩的地方，及后于1947年改建为餐厅。太平山餐厅的屋顶用红磗建成，因而有「红砖屋」的称号。餐厅提供各种质量卓越的国际佳肴美馔，装潢「中西合壁」，以老上海为主题，融入欧式乡村典雅，更设有露天花园，让客人在户外用餐时，可鸟瞰南中国海和薄扶林郊野公园的醉人景色。']
          },
          {
            title: '山顶缆车及山顶缆车历史珍藏馆',
            img: ['static/xingshan/img/Peak Tram_l.png'],
            content: ['山顶缆车于1888年启用，起初只为居住在太平山顶上的香港总督及富商提供服务，现已成为一项深受旅客欢迎的观光交通工具。山顶缆车的路轨全长1.4公里，复古外型的车厢几乎45度倾斜着攀升，一列缆车由两个车卡组成，两列缆车能够同时以相反方向行驶，每小时可以载客2,800人次，来往中环花园道及山顶两座总站的车程约7分钟。',
              '乘客可凭缆车票免费参观山顶缆车历史珍藏馆，认识这条逾百年历史的亚洲第一条缆索铁路的点滴。馆内设有15个主题展区，展出超过200件来自世界各地与缆车相关的丰富珍藏，此外还展出了一卡仿制第一代山顶缆车供游人参观和拍照。您更可在馆内了解缆车动力系统的设计和历史发展，细赏昔日山顶缆车售票员的制服、响铃车票打孔机售票系统和车票，以及风靡男女老少游客的缆车和火车收藏品。']
          },
          {
            title: '凌霄阁摩天台428',
            img: ['static/xingshan/img/The Peak Tower_l.png'],
            content: ['凌霄阁摩天台428位于海拔428米的山顶凌宵阁上，因而得名。不论日间或晚上到访这个360度全方位开放式的无敌观景台，皆可居高临下感受香港城市和大自然共融的独特面貌。',
              '摩天台的一边可俯瞰维多利亚港两岸的迷人景致，将中银大厦、国际金融中心、香港会议展览中心、环球贸易广场等著名香港地标尽收眼底；另一边则可眺望长洲、大屿山和南丫岛等离岛的醉人景色。您更可利用场内的免费Wi-Fi启动「香港摩天导览」语音互动导览服务，以生动的方式认识香港的历史、文化、建筑和生活故事。']
          },
          {
            title: '伯大尼修院内之小教堂',
            img: ['static/xingshan/img/Bethanie_Church_2_l.png'],
            content: ['伯大尼修院位于香港薄扶林道139号，于1875年落成，现为香港一级法定古迹。修院成立之初，是巴黎外方传教会在东亚地区的首间疗养院（入口铁门上面的「ME」字样正是巴黎外方传教会的缩写），其后由政府接管，于1978至1997年期间曾租予香港大学使用，现为香港演艺学院古迹校园。' ,
              '伯大尼修院内的小教堂是香港唯一一座新哥德式教堂，沿用拱形圆顶及飞扶壁设计，彩绘玻璃、12门徒的圣像及各种陈设，都带着19世纪法国传教士对信仰、感召和奉献的动人故事。小教堂所用的地砖亦是独一无二，相信是从法国进口。小教堂可容纳约150人，逢星期日及其他圣日举行礼拜，平日开放租予公众人士举行婚礼。']},
          {
            title: '伯大尼修院内之惠康剧院 - 牛奶公司牧场遗址',
            img: ['static/xingshan/img/Bethanie_Church_1_l.png'],
            content: ['香港政府于2003年将伯大尼修院和隔壁的牛奶公司牛棚批予香港演艺学院改建为校舍。在牛奶公司赞助下，香港演艺学院将邻近伯大尼修院的两座八角形牛棚，改建成小展览厅及惠康剧院，并于2007年3月改建完工，剧院适合各类表演、会议、电影放映、室乐演奏、实验演出等活动及小型演出。 ' ,
              '剧院现时仍保留原有的八角形屋顶和其中一座牛棚，让访客感受当年的牧牛情况。而昔日的牛奶公司牧场在1983年已关闭，留下牧场遗址。 2008年，伯大尼修院获联合国教科文组织颁发亚太区文物古迹保护奖的荣誉奖，以表扬其复修工程。']},
          {
            title: '薄扶林村',
            img: [],
            content: ['薄扶林村位于香港岛南区，历史可追溯至17世纪，因而有「未有香港，便先有薄扶林村」的说法。全村分为「围仔」、「菜园」和「龙仔督」三个主要部分，房屋以砖屋及铁皮屋为主。港岛的村落不少，但只有薄扶林村受到学者的重视，原因是目前只有在薄扶林村才能找到原居民的后裔聚居。' ,
              '2013年，薄扶林村成为首个登上「世界历史遗迹监察名单」的香港历史遗迹。有形遗产包括传统村庄房子和设置、李灵仙姐塔、牛屎湖；无形的遗产包括李灵仙姐诞和薄扶林村舞火龙等。2017年，薄扶林村舞火龙更获列入「香港非物质文化遗产清单」。沿着舞火龙活动的路线，便可参观薄扶林村各座主要历史建筑。']},
          {
            title: '中华厨艺学院中菜馆',
            img: [],
            content: ['位于薄扶林的中华厨艺学院，是职业训练局旗下提供中菜烹调课程的专门学院，以宏扬中华饮食文化为使命。学院设有食品科学实验室、训练厨房、出品厨房、训练餐厅和酒廊等设施，让学员在真实的工作环境下学习。作为学院中式训练餐厅的中菜馆，位于综合大楼7楼，由迎宾、烹调到上菜，客人都可以感受到学院训练的严谨，以及学员对中华厨艺的热诚。' ]
          },
          {
            title: '珍宝海鲜舫',
            img: ['static/xingshan/img/Jumbo Seafood Restaurant_l.png'],
            content: ['珍宝海鲜舫于1976年建成开业，是停泊于香港岛南区香港仔深湾的水上餐厅。珍宝海鲜舫楼高三层，面积达45,000平方呎，可容纳逾2,300名宾客，因此有「世界上最大的海上食府」之称，是外国游客必到之地，至今累积游客人次超过3,000万。在传统中国宫殿装修的餐厅内，客人可享用各式海鲜美馔、传统及新派美食，不少中外政要、商界名人和国际巨星都曾是座上客。珍宝海鲜舫也是许多著名电影，例如《生死恋》、《龙争虎斗》、《无间道2》以及《食神》的取景场地。夜间的珍宝海鲜舫五光十色，名副其实是香港的海上明珠。' ]
          }
        ]
      },
      rules: {
        title: '万步有礼  送出100部智能手机',
        list: [
          '为了鼓励全港市民响应「为健康 一齐行」，于12月16日当天，除了《中移动香港行山节》启动礼外，将同时举办一个「万步有礼」活动，目标是吸引全港市民一同创出「亿步行」的壮举。',
          '认识香港，从你的眼中开始！香港24个郊野公园各有独特的美丽景观，跟香港繁忙灿烂的都市景致相映成趣，从不同角度均散发魅力。因此，在活动当天（12月16日- 00:00-23:59），所有参加者只需登入MyLink App，无论行山、行街、或行去任何地方，以MyLink App计步器录得10,000步后，即奖你中银集团保险「保险计划优惠包」优惠码，如属中国移动香港客户更可获得$20元电子缴费券或增值券。同时上载「最能代表香港的相片」一张到WeWalk「万步有礼」活动内，更有机会获得智能手机一部。',
          '参加相片将由专业评审团选出150名进入公众投票阶段，最高票数之100名将有机会获赠智能手机乙部，而其余50名入围者亦有机会获赠行山节精美背包乙个。100名得奖作品更将会被制作成为手机壁纸，免费供公众下载。',
          '大会期望透过是次活动，鼓励全港动起来、向健康出发，落实「为健康 一齐行」，同时让更多香港人欣赏这个美丽城市的郊野风光及都市景致，为香港大都会发掘更多魅力。'
        ],
        time: {
          title: '活动时间表',
          list: [
            '活动日期: 2018年12月16日',
            '活动时间: 00:00-23:59',
            '作品甄选: 2018年12月17日至12月24日',
            '公众投票: 2018年12月24日凌晨00:00至12月30日晚上23:59',
            '投票渠道: MyLink 手机应用程式',
            '公布得奖日期 : 2019年1月7日中午12时',
            '公布渠道: MyLink 手机应用程式'
          ]
        },
        join: {
          title: '参加方法',
          list: [
            '下载MyLink 手机应用程式',
            '开启「生活」内WeWalk页面',
            '当天必须行满1万步后，计步器将会发出提示',
            '当日拍摄一张香港照片连同标题 (相片档案限制：不超过5MB)上载至WeWalk'
          ]
        },
        reward: {
          title: '奖品',
          list: [
            '参加者只要行满1万步后，即可获得中银集团保险「保险计划优惠包」优惠码，如属中国移动香港客户更可获得电子缴费劵或增值券（价值$20）。',
            '参加相片将由专业评审团选出150名进入公众投票阶段，公众投票最高票数之100名将获赠智能手机乙部，其余50名入围者可获赠行山节精美背包乙个。详情如下：'
          ],
          table: [
            {
              label: '票数排名第一至第五名',
              value: 'iPhone XS (256GB)'
            },
            {
              label: '票数排名第六至第十名',
              value: 'Samsung Galaxy S9+ (256GB)'
            },
            {
              label: '票数排名第十一至第二十五名',
              value: 'iPhone 8 (256GB)'
            },
            {
              label: '票数排名第二十六至第三十名',
              value: 'HUAWEI Mate 20 Pro'
            },
            {
              label: '票数排名第三十一至第五十五名',
              value: 'HUAWEI P20'
            },
            {
              label: '票数排名第五十六至第八十名',
              value: 'Samsung Galaxy A8+'
            },
            {
              label: '票数排名第八十一至第一百名',
              value: 'iPhone SE (128GB)'
            },
            {
              label: '票数排名第一百零一名至第一百五十名',
              value: '「中移动香港行山节」指定背囊'
            }
          ]
        },
        ruleL: '有关活动之条款及细则，请',
        ruleR: '按此',
        ruleRR: '',
        article: '活动简介：',
        info: '不论你是否中国移动香港的客户，都可于活动期间2018年12月16日10:00至17:00登入MyLink App，进入「MyLink 万步有礼」专页，按「开始活动」开启计步功能，并在计步期间内一直开启MyLink App。当你的步数达到10000步时，可获得换领礼品的机会一次。',
        linkText: '查阅【MyLink 万步有礼】活动详情及细则'
      },
      prize: {
        title: '当参加者达成以下得奖规则所订下之目标，即有资格获得以下奖项及礼品：',
        prizeA: '全城有奖',
        prizeAList: [
          '规则：凡于活动期间用MyLink计步器计步步数达5000步，即有资格获取以下礼品。礼品数量没有限制：',
          '1GB 4.5G本地数据用量',
          '$20电子缴费券',
          '$20电子增值券',
          '中银集团保险「环宇遨翔旅游保障计划」优惠码68折'
        ]
      },
      submit: '立即报名',
      submitConfirm: '抽签结果查询',
      submitSign: '签到',
      submitWalk: '参与活动',
      submitConfirmed: '参加12.16「万步有礼」活动'
    },
    walk: {
      title: 'MyLink 10000步有礼',
      bg: 'static/xingshan/1w-bg-sc.jpg',
      startLabel: '开始时间',
      startTime: '早上10:00',
      endLabel: '结束时间',
      endTime: '下午5:00',
      actTime: '活动日期：',
      invite: '邀请你参加MyLink 10000步有礼',
      desc: '每天运动其实不难，今天就由10000步开始，踏出健康生活第一步，为健康，一齐行。「中移动香港行山节」除了在12月16日会在山顶公园举行开步礼外，更鼓励当日所有市民，在全港任何一个角落进行步行运动，在指定的时间内，步数达到10000步或以上，更可获得丰富奖品，全城有奖！',
      actDetail: '活动简介',
      detail: '不论你是否中国移动香港的客户，都可于活动期间2018年12月16日10:00至17:00登入MyLink App，进入「MyLink 10000步有礼」专页，按「开始活动」开启计步功能，并在计步期间内一直开启MyLink App。当你的步数达到10000步时，可获得换领礼品的机会一次。',
      detail1: '1. 正式开始活动前，一定要有下载最新版本的 MyLink App。你可以到以下的App Store或 Google Play的连结下载。',
      detail2: '2. 活动期间2018年12月16日10:00至17:00登入 MyLink，进入「生活」>「一齐行」页面，进入「MyLink 10000步有礼」专页。',
      detail3: '3. 按「开始活动」开启计步功能，并在计步期间内一直开启MyLink App。',
      detail4: '4. 当你的步数达到10000步时，系统会自动纪录换领奖品的机会。',
      prize: {
        title: '奖项及礼品介绍',
        text1: '每位合资格用户最多可获两份礼品，包括中银集团保险「保险计划优惠包」优惠码、中国移动香港的电子券（价值$20）等。',
        text2: '10000步到底有几多？',
        text3: '若果以一个身高1.7米的人来计算，平均10米大约走16步，1公里就大约1600步了。10000步，就是约6公里了，也就是由山顶广场到薄扶林的步行距离了。',
        text4: '平均来说，香港人普遍一日走的步数约在6000-8000步之间，上世纪60年代，开始有研究建议，如果每日走10000步，再配合适当的步速及维持中度的心跳速度的话，长期有助改善心脏及血管健康。',
        text5: 'MyLink App中的计步器功能，可以准确地量度步行时手持手机的摇摆幅度，从而计算出步数，更可跟朋友分享你的运动成果。只需每天登入MyLink，保持连线状态，就可容易方便地纪录你的步数和卡路里消耗。你今日又走了几多步？'
      }
    },
    inter: {
      title: '中移动香港行山节',
      title1: '中移动香港行山节',
      bg: 'static/xingshan/inter-bg-sc.png',
      subTitle: '全港动起来 向健康出发 为健康 一齐行',
      invite: '邀请你参加中移动香港行山节',
      desc: '「中移动香港行山节」由中国移动香港和中国香港旅行远足联会联合主办，目的是推动全港市民参与，提高市民步行及行山的健康意识，为健康，一齐行，同时希望将「远足」打造成为「香港名片」由香港出发，面向国际宣传香港是远足活动的首选热点。',
      desc1: '大会举办行山节，旨在推广香港行山路径及郊野公园，如是次活动选址的山顶环回步行径和薄扶林水塘家乐径；而凤凰径、麦理浩径、卫奕信径等亦是香港著名的行山径。大会期望鼓励市民一齐行，携手发掘香港郊野公园的特色，推而广之成为香港旅游的重点。',
      back: '进入「第二届中移动香港行山节」',
      url1: 'https://www.wewalk.hk/zh-hans/2018/12/17/%e4%b8%ad%e7%a7%bb%e5%8a%a8%e9%a6%99%e6%b8%af%e8%a1%8c%e5%b1%b1%e8%8a%82/',
      url3: 'https://mylink.komect.com/activity/via/mountainreview/index.html?lang=sc',
      back1: '进入「第一届中移动香港行山节」',
      back3: '进入「第三届中移动香港行山节」',
      back4: '进入「第四届中移动香港行山节」',
      back5: '进入「第五届中移动香港行山节」',
      uaturl4: 'https://uatoss.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/four?lang=sc',
      uaturl5: 'https://uatoss.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/five?lang=sc',
      paturl4:'https://cdn.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/four?lang=sc',
      paturl5:'https://cdn.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/five?lang=sc',
    },
    login: {
      title: '活动登记',
      phone: '手机号',
      mobilePlaceholder: '请输入手机号',
      codePlaceholder: '请输入验证码',
      sendCode: '获取验证码',
      submit: '提交',
      tip: {
        mobileEmpty: '请输入手机号',
        mobileError: '请输入正确的手机号',
        codeEmpty: '请输入验证码',
        codeFail: '获取验证码失败',
        codeError: '请输入正确的验证码',
        codeExpired: '验证码已过期，请再取新一个验证码',
        checkFail: '系统繁忙, 请稍后再试！'
      }
    },
    sign: {
      title: '活动登记',
      nameLabel: '姓名',
      lastName: '姓',
      firstName: '名',
      emailLabel: '电邮',
      emailPlaceholder: '请输入电邮地址',
      routeLabel: '参加路线',
      extraPersonLabel: '是否携带其他人员参加',
      yes: '是',
      no: '否',
      submit: '提交',
      personNumList: [{ key: 1, value: '1 人' }, { key: 2, value: '2 人' }, { key: 3, value: '3 人' }],
      rules1: '本人声明本人已年满18岁(年龄以活动当日计算)。本人及同行参加者细阅并同意本活动之',
      rules1_1: '及',
      rules1_2: '。主办机构保留取消不接受上述条款之参加者的参加资格。',
      rules2: '本人同意接收中国移动香港有限公司提供的最新资讯',
      rulesLinkText: '「参加者须知及条款细则」',
      rulesLinkText1: '「免责声明」',
      rulesLinkText2: '「个人资料收集声明」',
      rulesLink1: '/xingshan/sign/privacy',
      rulesLink2: '/xingshan/sign/personal',
      tip: {
        nameEmpty: '请输入正确姓名',
        errorEmail: '请输入正确电邮格式',
        existEmail: '该电邮已被使用',
        routeEmpty: '请选择参与线路',
        personEmpty: '请选择携带人数'
      },
      dialog: {
        title: '活动登记信息如下',
        nameLabel: '姓名：',
        phoneLabel: '电话：',
        emailLabel: '电邮：',
        routeLabel: '已选择路线：',
        extraLabel: '额外参与人数：',
        yes: '提交',
        no: '取消',
        personUnit: '人'
      },
      rules: {
        title: '参加者须知及条款细则',
        infor: '「中移动香港行山节」 - 山顶行山活动条款及细则',
        dt1: '参加者须知及条款细则',
        list1: [
          '「中移动香港行山节」由中国移动香港有限公司(「中国移动香港」)及中国香港旅行远足联会(「旅联」) 联合主办。',
          '在下列的条款及细则内「活动」乃指2018年12月16日举行的「中移动香港行山节」山顶行山活动；「参加者」为参与是次活动的人士；「主办机构」为中国移动香港及旅联；「路线」是由主办机构指定的行山路线。',
          '参与活动确认一经递交，即代表参加者及额外同行参加者确认及同意接受一切主办机构不时所定之活动的规则、条款和安排。',
          '18岁以下参加者必须于[2018年12月10日]或之前以电邮(wewalk.enquiry@gmail.com)方式向主办机构提交已签署之家长/监护人同意书。主办机构保留取消于限期前未能提交同意书之18岁以下参加者的参加资格。'
        ],
        dt2: '活动细节',
        list2: [
          '活动设有家庭乐组及公开组。家庭乐组没有年龄限制，但家庭乐组组长必须于活动当日年满18岁。公开组参加者必须于活动当日年满12岁。每名16岁以下之参加者必须由18岁或以上的成年人陪同参加。 18岁以下的参加者必须事先获家长或监护人签署同意书方可参加。主办机构保留在活动前后或进行期间，核实参加者年龄及(如有需要)该等同意书证明的权利。',
          '主办机构在得悉或怀疑情况下，保留、限制拒绝接受报名或取消任何不适宜参加本活动的参加权利，包括但不限于如申请者提供错误资料、不能提交报名表、不依从正确报名程序报名、或身体状况不适宜参加本活动(如怀有身孕、患慢性疾病如心脏病及高血压人士)。',
          '参加者必须最迟于活动当天上午1​​1时30分抵达山顶广场对出空地，逾时者会被取消参加资格。若参加者未能按照其指定参加组别及时间起步，或未能依循所报名的路线完成活动，主办机构有权取消其参加资格，有关参加者将不会获发纪念奖牌及证书。',
          '参加者不可携带或使用任何滚轴鞋、滑板、手推车或其他大型物件，亦不可携同任何动物参与。',
          '参加者于活动前后及进行期间，必须遵照主办机构、授权人员以及其他工作人员包括警察、民众安全服务队、医疗辅助队、食物环境卫生署及康乐及文化事务署的所有合法指示。',
          '参加者请于活动期间保持专业及礼貌的态度。',
          '步毕家庭乐组路线全程约需1小时；步毕公开组路线全程约需2小时。沿途部分地区并无遮盖，参加者需确保体力适宜才参与，如有疑问，应先向医生查询。如未能步毕全程，可于中途退出，部分退出点有公共交通工具接驳。活动实际完结时间以主办机构及授权人员所安排的押尾小队决定为准。',
          '参加者需穿上合适的衣服及鞋袜，并自备充足饮品、食物、帽及雨具等。',
          '是次行山活动途径车路及泥路小径，参加者须特别小心。请勿奔跑、争先恐后、倚靠或攀爬沿途任何物件，以确保安全。',
          '参加者需自行承担一切责任。主办机构及授权机构并不会对参加者于活动当天因任何事情或理由所引致的任何个人伤亡或财物损失承担任何责任。',
          '主办机构保留更改条款细则、路线等安排的权利。',
          '主办机构若认为参加者没有完全遵照或违反本条款及细则的规定，主办机构有权取消参加者的资格或于行山活动中任何时间内终止参加者继续参加。主办机构的判决为最终及不可推翻的决定。'
        ],
        dt3: '恶劣天气',
        list3: [
          '如天文台于活动当日早上六时或之后悬挂黑色暴雨、红色暴雨、雷暴或三号台风警告，活动将会取消，主办机构将另择日子举行活动。',
          '如活动进行中天气恶劣或悬挂任何天气警告，又或主办机构评估后判断当天并不适合举行活动，主办机构有权将活动路径改变或取消正在进行中的活动。主办机构不会另择日子补办活动。',
          '如是次活动因天气恶劣或悬挂任何天气警告或其他原因而取消，主办机构将另行通知活动补办日期。',
          '主办机构强烈要求参加者于活动举行当天早上致电香港天文台查询天气情况。 (电话：1878200)'
        ],
        dt4: '其他事宜',
        list4: [
          '主办机构不会提供行李寄存。切勿携带贵重物品，如有损毁或遗失，主办机构将不会负任何责任及作出任何赔偿。',
          '参加者如活动过程中须向主办机构查询及要求协助，请沿途与就近工作人员联络。',
          '所有由主办机构提供的活动包、礼品及任何其他物品(「礼品」)不可兑换现金，亦不能更换、退款、转让及转售。本活动所有的礼品视乎供应情况而定，换领完即止。每名参加者只可领取一份活动包，不可代他人领取。如任何因礼品所引起的争议，主办机构概不负责。',
          '主办机构对供应商提供的商品或服务之品质、安全性及合法性，刊登内容之真实性及准确性，供应商的商誉与可信性均无控制力及保证。',
          '参加者需自行负责个人意外保险。',
          '主办机构保留使用活动当天所拍得照片或录像的权利，包括商业宣传用途。',
          '主办机构保留本活动的最终决定权。活动不设上诉机制。主办机构拥有修改及解释本条款规则的权利，任何有关活动的临时改动或取消，将以主办机构公布为准。',
          '本条款及细则受香港法律管辖。参加者同意任何因本条款及细则所引起的任何诉讼或索赔受香港法院的专属司法管辖权管辖。',
          '本条款与细则的中、英文本如有任何歧义，概以英文本为准。',
          '如有任何争议，主办机构将保留一切最终决定权。'
        ],
        r9: '参加者不可携带或使用任何滚轴鞋、滑板、手推车或其他大型物件，亦不可携同任何动物参与。',
        r10: '电话：2127 4720 (星期一至五早上10时至晚上7时)',
        r11: '电邮：wewalk.enquiry@gmail.com',
        r12: '大会拥有修改及解释以上规则的权利。'
      },
      personal: {
        title: '个人资料收集声明',
        list: [
          '主办机构将会在参加者确认出席「中移动香港行山节」山顶行山活动时，收集参加者的个人资料，包括姓名、手提电话号码等。主办机构保障参加者所提供之一切资料。当参加者提交确认时，有关个人资料将会被收集、储存及使用以作核实。',
          '本声明乃遵照《个人资料(私稳)条例》(第486章)的要求而发出，通知您作为参加者收集资料的目的、您同意主办机构如何使用这些资料及您的权利。本声明会不时更改，故请定期查阅。参加者每次登记及/ 或使用我们的服务时，即表示同意接受当时生效之个人资料收集声明。',
          '参加者可能会被要求向主办机构提供个人识别资料。为让参加者可以参加「中移动香港行山节」山顶行山活动，该些资料是必要的。倘若参加者未能提供所需资料，参加者将不能获得参赛资格。'
        ],
        dt1: '资料之目的及用途',
        list1: [
          {
            title: '主办机构所收集之资料将用作以下用途：',
            list: [
              '识别和核实参加活动的参加者的身份及/ 或资格',
              '就有关或因参加活动的事项与参加者或其紧急联系人沟通',
              '汇编参加者的整体统计资料，分析、评估及改进主办机构所提供的活动'
            ]
          }
        ],
        dt2: '资料之转移',
        list2: [
          '参加者之个人资料将被保密。然而由于系统管理、运作及保养需要，主办机构会将有关资料转移或披露予对主办机构有保密责任并提供与主办机构运作有关行政、电讯、电脑系统服务、数据处理或其他服务的承办商。',
          '参加者有权根据《个人资料（私隐）条例》(第486章)的规定，要求查阅或更正参加者之个人资料。如有任何查阅或更正资料的要求，请向本公司资料保障主任提出，其办事处位于香港新界葵涌葵昌路51号九龙贸易中心1座20楼。主办机构的私隐政策声明可于其网页www.hk.chinamobile.com获取。'
        ]
      },
      privacy: {
        title: '免责声明',
        info: '谨此声明本人参加本活动，并愿意遵守由主办机构所订的条文及规则，以及同意以下所列各点：',
        list: [
          '本人是自愿参加此活动和愿意承担自身的意外风险及责任，并无权向主办机构对本人往返活动场地途中、活动中发生或引致之自身意外、死亡或任何形式的损失提出索偿或追讨责任。',
          '本人声明本人身体情况良好及有能力参加此活动，及没有执业医生曾提出相反意见。',
          '本人愿意接受主办机构要求及提供的药物检查及治疗。',
          '本人于活动当天（2018年12月16日）已经符合参加组别之最低年龄规定（如参加者未年满18岁，须由其家长或监护人签署同意声明）。',
          '本人明白及同意本人的个人资料将转交予主办机构用作活动安排之用途。',
          '本人证实已事先获得同行参加者及/或紧急联系人的同意，可使用其个人资料于本活动的报名表格作报名及/或紧急联系用途。',
          '本人愿意授权予及同意主办机构及传媒在不需要审查情况及不需要本人另外同意下而可使用本人的个人资料、肖像、姓名及声线作为筹办及推广活动之用，包括本人肖像及姓名有可能被使用于主办机构有关本活动之网页、短片及刊物。',
          '本人提交确认即表示同意及确认所有列明之「参加者须知及条款细则」、「免责声明」及「个人资料收集声明」，以及所有不时于活动指定宣传渠道更新的任何更改。'
        ]
      }
    },
    error: {
      title: '系统繁忙',
      info: '活动登记失败，请返回再试'
    },
    result: {
      title: '登记结果',
      // 登记
      registered: {
        title: '登记查询',
        article: '已登记',
        info: '阁下已登记参与12月16日「中移动香港行山节」，为健康，一齐行！',
        info1: '大会将以抽签形式抽出当日出席开步礼的参加者，并于12月1号以短讯通知结果。敬情留意！',
        info2: '',
        tip: '您可同时参与12月16日举办的《MyLink 万步有礼》，在指定的时间内，步数达到万步或以上，即有资格赢得丰富奖品，全城有奖！',
        registeredLabel: '活动登记信息如下：',
        nameLabel: '姓名：',
        phoneLabel: '电话：',
        emailLabel: '电邮：',
        routeLabel: '参加路线：',
        extraLabel: '额外参与人数：',
        link: '查阅【MyLink 万步有礼】活动详情及细则',
        personUnit: '人'
      },
      success: {
        title: '登记查询',
        article: '登记成功',
        info: '阁下已登记参与12月16日「中移动香港行山节」，为健康，一齐行！',
        info1: '大会将以抽签形式抽出当日出席开步礼的参加者，并于12月1号以短讯通知结果。敬情留意！',
        info2: '',
        tip: '您可同时参与12月16日举办的《MyLink 万步有礼》，在指定的时间内，步数达到万步或以上，即有资格赢得丰富奖品，全城有奖！',
        link: '查阅【MyLink 万步有礼】活动详情及细则'
      },
      // 报名确认
      confirmed: {
        title: '提交结果',
        article: '成功确认参与！',
        registeredLabel: '活动参与信息如下：',
        nameLabel: '姓名：',
        phoneLabel: '电话：',
        routeLabel: '已选：',
        extraLabel: '额外参加者的资料如下：',
        extraItemLabel: '额外人员',
        ps: '重要讯息：有关12月16日当天的交通及集合安排，大会将以短信方式发送至阁下手机，敬请留意。',
        rules: {
          title: '中移动香港行山节 <br/> 万步有礼 送出 100 部智能手机',
          list: [
            '为了鼓励全港市民响应「为健康 一齐行」，于12月16日当天，除了《中移动香港行山节》启动礼外，将同时举办一个「万步有礼」活动，目标是吸引全港市民一同创出「亿步行」的壮举。',
            '在活动当天（12月16日- 00:00-23:59），所有参加者只需登入MyLink App，无论行山、行街、或行去任何地方，以MyLink App计步器录得10,000步后，即奖你中银集团保险「保险计划优惠包」优惠码，如属中国移动香港客户更可获得$20元电子缴费券或增值券。同时上载最能代表香港的相片一张到WeWalk「万步有礼」活动内，更有机会获得智能手机一部。',
            '参加相片将由专业评审团选出150名进入公众投票阶段，最高票数之100名将有机会获赠智能手机乙部，而其余50名入围者亦有机会获赠行山节精美背包乙个。100名得奖作品更将会被制作成为手机壁纸，免费供公众下载。'
          ],
          link: '万步有礼 创纪录 赢手机 详情'
        }
      },
      noregistered: {
        title: '提交结果',
        article: '抱歉！',
        info: '系统未能找到您的登记资料。',
      },
      nowinning: {
        title: '提交结果',
        article: '抱歉！',
        info: '多谢阁下报名参加 「中移动香港行山节」，由于反应热烈，是次活动名额已满，再次多谢各位踊跃支持！我们鼓励阁下当日一同参与「万步有礼 创纪录 赢手机」'
      },
      // 签到
      signSuccess: {
        title: '签到结果',
        article: '阁下已签到！'
      },
      signed: {
        title: '签到结果',
        article: '阁下已签到！'
      },
      needSign: {
        title: '签到结果',
        article: '抱歉！',
        info: '需要参与活动的队长扫QRCODE以签到～'
      },
      sign: {
        title: '签到结果',
        article: '签到信息确认',
        signCheck: '一经签到后，人数不能改变！'
      },
      signFail: {
        title: '签到结果',
        article: '未能查询阁下参与活动信息，请与工作人员联络。'
      }
    },
    loginConfirm: {
      title: '抽签结果查询',
      subTitle: '请输入用于登记本活动之手机号码'
    },
    signConfirm: {
      title: '活动报名',
      subTitle: '恭喜！您已被抽中参与「中移动香港行山节」，请填写以下的报名资料以确定报名资格。',
      subTitle1: '请填写以下报名资料：',
      routeLabel: '参加路线：',
      nameLabel: '紧急联络人姓名',
      lastName: '姓',
      firstName: '名',
      phoneLabel: '紧急联络人电话',
      phonePlaceholder: '手机号码',
      extraPersonLabel1: '额外参加者（最多',
      extraPersonLabel2: '人）',
      extraPersonLimit: '3',
      addExtra: '增加额外参加者',
      extraEmCheckbox: '使用和我相同的紧急联络人资料',
      extraDifferent: '新增的额外人数与登记活动时人数不同，是否继续提交？',
      rules1: '大会会于活动当日在金钟海富中心有免费接驳巴士前往山顶广场，您和您的队员会否采用？',
      rules2: '本人声明上述同行参加者中有18岁以下参加者。本人同意大会将会按本人所提供的电邮地址，以电邮提供家长/监护人同意书。本人明白必须于2018年12月10日或之前以电邮交回已签署之家长/监护人同意书相关参加者才可参与本活动。主办机构保留取消于限期前未能提交同意书之18岁以下参加者的参加资格。(18岁以下参加者适用，年龄以活动当日计算)',
      tip: {
        errorPhone: '请输入正确的手机号码',
        repeatPhone: '请提供一个不同的额外参加者联系电话',
        errorEmergencyPhone: '请输入正确的紧急联络人手机号码',
        emergencyNameEmpty: '请输入正确的紧急联络人姓名',
        unavailableExtra: '此额外的参加者已报名，您可删减或增加其他参加者',
        notice: '提示',
        delExtra: '是否删除此额外人员信息？'
      },
      extraListLabel: {
        title: '额外人员',
        name: '姓名',
        phone: '电话',
      },
      advance: '[万步有礼] 活动将于12月16日正式举行'
    },
    transferConfirm: '抽签结果 密切留意',
    bindPhone: {
      title: '绑定手机号'
    },
    walkNotEnough: {
      title: '万步有礼',
      info: '距离万步还差{{step}}步，请继续努力！完成后有机会赢取智能手机大奖。',
      unit: '步',
      left: '距离万步还差：',
      countInfo: '总步数',
      submit: '返回首页'
    },
    walkReward: {
      title: '得奖结果',
      ad: {
        title: '[万步有礼]活动，赢手机',
        info: [
          '大会鼓励全民运动，特意举办「万步有礼」活动。',
          '全港市民只要在12月16日当日开启MyLink手机应用程序，透过WeWalk页面内的计步功能并步行够一万步，即可在MyLink上载一张行山香港照片。',
          '大会将会精选150张最精彩的相片，并由公众投票，获得最多票数的头100位参赛者将有机会获智能手机一部！'
        ],
        submit: '参与活动'
      },
      reward: {
        title: '阁下完成【万步有礼】活动，获得奖品如下：',
        submit: '详情'
      },
      photoInfo: '阁下参与「万步有礼」摄影活动的资料如下：',
      noData: '沒有纪录',
    },
    photoUploadHome: {
      title: '「万步有礼」活动',
      rulesText: '本人同意【万步有礼】',
      rulesLinkText: '活动条款及细则',
      rulesText1: '',
      submit: '开始',
      adImg: 'static/xingshan/wanbu-sc.jpg'
    },
    photoUpload: {
      title: '「万步有礼」活动',
      addFile: '上载照片',
      name: '相片标题',
      namePlaceholder: '相片标题',
      userNamePlaceholder: '输入姓名',
      submit: '上传',
      loading: '上传中...',
      tip: {
        yes: '确定',
        notice: '注意',
        photoName: '中文上限10个字，英文上限20个字',
        userName: '须与香港身份证上姓名相同',
        error: '系统繁忙，请稍后再试'
      }
    },
    photoUploadResult: {
      title: '「万步有礼」活动',
      successTip: '图片上传成功！',
      successInfo: '入围作品将在2018年12月24日公布结果，敬请留意！',
      upLoadLabel: '上传：',
      nameLabel: '姓名：',
      phoneLabel: '手机号码：',
      titleLabel: '相片标题：',
      return: '返回首页'
    },
    photoRules: {
      title: '条款及细则',
      organizer: {
        title: '主办机构',
        list: [
          '「中移动香港行山节—万步有礼」活动由中国移动香港有限公司（「中国移动香港」或「主办机构」）主办。',
          '参加者一旦参与活动，即代表了解、同意并愿意遵守本文所载的条款及细则，如有违反条款、以不诚实手法进行此活动及、或造假者，中国移动香港有权取消其参加及得奖资格，而不作任何通知。'
        ]
      },
      bili: {
        title: '参加资格',
        list: [
          '所有的公众人士于香港时间2018年12月16日00:00至当日23:59步行达10,000步或以上，即可参加本活动。10,000步只以MyLink手机应用程式内计步功能计算为准，其他任何计步器纪录恕不接受。参加者如未满十八岁，必须先获家长/监护人签署同意书方可参加。主办机构有权要求参加者出示年龄证明及（如有需要）该等同意书证明。',
          '参加者必须于Google Play 或 App Store 下载MyLink手机应用程式（「MyLink」）。中国移动香港客户（包括现有的储值卡客户、服务计划客户及用身份证登记的企业客户）需以电话号码及客户密码登入MyLink; MySim客户及非中国移动客户需于活动专页输入电话及验证码登入MyLink。所有参加者必须同意本活动条款及细则，才可参加本活动。',
          '参加者必须提供支援短信功能的香港手机号码以获得一次性验证码进行身份验证。如登记的手机号码不支援短信功能或不能使用、无效或在领取礼品时已经更改，该得奖资格会被取消。',
          '参加者必须于活动期间登入MyLink，并在计步期间一直开启MyLink及维持流动数据功能，活动期间累计步数将由香港时间12月16日00:00开始截至12月16日23:59 (香港时间)为止。',
          '活动只限香港注册的流动电话号码用户参与，每个香港流动电话号码只限参加一次。如发现参加者以外挂程式或其他非正式途径如空号或假帐户或其他影响公平性​​的方式参加本活动，中国移动香港将取消该参加者的资格而不作另行通知。',
          '中国移动香港保留对参加者资格的最终决定权。'
        ]
      },
      time: {
        title: '活动日期',
        list: ['活动日期于香港时间2018年12月16日00:00至当日23:59期间进行。提交相片时间以中国移动香港伺服器所收到作品之时间作准，逾时提交作品将不获受理。']
      },
      notice: {
        title: '参加须知',
        list: [
          '参加者须清楚明白本活动内容及性质，并知道本活动需要消耗体力，同时确定健康情况适宜参与本活动。主办单位建议所有参加者于活动期间自行留意个人的身体状况是否良好及是否适合参与本活动。参加者于活动期间如有不适，请立即停止活动，并按需要向医护人员求助。',
          '参加者参加本活动纯属自愿性质及需自行承担参加本活动之风险。任何参加者因参加本活动而引致之任何损失、伤害、费用、索赔、诉讼（包括但不限于直接、间接及后果性损失），主办单位概不负上任何法律责任或作出赔偿。',
          '如主办单位怀疑参加者有 （i）进行或与异常/可疑活动有关、（ii）使用不当的方法或欺诈行为而使本活动任何部份运作中断或受到干扰，导致技术问题，或检测到（iii）任何不诚实的行为、提供虚假或不正确的资料或（iv）任何违反本条款及细则或其他任何适用法律或条文；主办单位拥有酌情权及最终决定权在不作任何通知及毋须对任何人士负上任何责任的情况下自行决定取消其参加及/或得奖资格，并对该人士保留追究权利。',
          '参加者于登记参加本活动时所提供的资料均不能更改。如登记页面上所提供的资料有任何错漏、不实或不正确，该登记则被视为无效。如得奖者因提供了虚假、错漏或不正确的资料而导致无法收到领奖通知或不能领取礼品，主办单位毋须为此承担任何责任。',
          '主办单位保留随时更改本活动内容、终止本活动、修订此条款及细则的权利，而无需另行通知。'
        ]
      },
      pedometer: {
        title: '有关MyLink计步功能',
        list: [
          '参加者必须于活动期间开启MyLink及维持流动数据才能累积步数，如因任何技术中断或错误、网络挤塞或其他任何原因而产生或引致任何迟延、遗失、错误或无法辨识的回应、登记或提交等情况，主办单位概不负责。参加者明白及同意不会就MyLink的数据提出任何异议。',
          '参加者可在活动期间登入MyLink，检视MyLink计步器的步数。',
          '参加者明白不同装置的计步器或有差距，一切结果会以主办单位的电脑系统所示的步数纪录为准。iOS装置会存取Apple内置传感器的步数纪录; 而Android装置会存取内置计步器/加速度传感器的步数纪录，任何其他第三方之计步方式均不获接受。',
          '计步功能只支援iOS版本9.0或以上及iPhone 5S或以上型号之手机，而Android手机则需内置计步感应器及系统为［4.4］或以上及之指定型号手机，并须视乎手机生产商对个别手机型号之设定为准。'
        ]
      },
      upload: {
        title: '有关上载相片活动',
        list: [
          '当参加者于活动期间步数达到10,000步时，可按指示上载相片并可获得换领礼品的机会一次。',
          '参加者须拍摄一张最能代表香港的相片，连同自创标题上载至MyLink手机应用程式。',
          '参加者只可递交一张作品，档案大小限制为5MB，惟必须递交原创并未经发布的相片，并为作品之唯一版权持有人。递交作品时需要同时输入最多十个中文字（连同标点符号）或最多二十个英文字母（连同空格及标点符号）的标题，但毋须递交作品描述。参加者只得一次机会上载相片，提交后不得更改。如系统发现有参加者重复提交相片，将会被取消资格。',
          '参加作品须为数码档案，不限定使用数码相机所摄之相片，亦接受负片、幻灯片、冲印相片之数位扫描档案。',
          '主办机构接受环景相片、黑白相片、高动态范围（HDR）影像或以鱼眼镜头拍摄的相片。参加者仅能对相片进行少量色彩加深（burning）、色彩加亮（dodging）或色彩校正（color correction）修改，适度裁切、黑白处理亦可接受。上述未提及之相片修改方式，一律禁止。若经查觉，该相片将丧失参加资格。',
          '主办机构不接受含有任何浮水印的参加作品。',
          '主办机构建议参加者保留未经软件后制（如效果、滤镜）或其他任何影像处理软体后制过的原始数码档案。主办机构审理有后制争议的作品时，或会要求参加者提供原始档案，如参加者无法提供，会被取消资格。',
          '主办机构将选出150张相片供公众投票。中国移动香港将以参加作品的美感、创意及原创性作为评审准则。如活动接获少于150张相片，主办机构筛走不合适相片后，其余所有相片将交予公众投票。150张相片在MyLink手机应用程式显示的先后次序将根据上载时间而定，依据中国移动香港伺服器纪录，较先上载的相片会获较前显示位置。',
          '公众投票将于MyLink手机应用程式进行，投票者须为MyLink已登入的用户。投票日期为香港时间2018年12月24日00:00至12月30日23:59。每位投票者只有一次投票机会可投选一张至五张相片，但只可投选同一张相片一次。各张相片所获票数将会实时显示。',
          '如发现有相片票数有可疑情况，包括但不限于以外挂程式或其他非正式途径如空号或假帐户或其他影响公平性​​的方式进行投票，中国移动香港将取消该参加者的资格而不作另行通知。中国移动香港对可疑情况的阐述及决定有最终决定权。',
          '参加者一经参与活动，即表示同意中国移动香港有永久免版权费及非独家使用权将相片用于中国移动香港的：(i)印刷刊物 (ii)网上刊物及 (iii)其他宣传媒体活动。作品一经提交于本活动完结后将不会发还予参加者。',
          '任何因电脑或电子装置故障、网络等技术问题而引致参加者未能准时提交参加作品，或有遗失、错误、无法辨识等情况，中国移动香港不会承担任何责任。经网络的送递证明亦不可视作成功传送参加作品的证明。',
          '主办机构保留对任何参加作品，不接受或不公开的权利，包括但不限于，有关于诽谤、诋毁、淫秽、色情、辱骂、攻击、亵渎的内容或者侵犯任何版权或任何人的其他权利的内容。如果参加作品胜出后确认相片不适合，主办机构保留撤销获奖的权利。',
          '参加者须保证上载作品不涉及粗言秽语及任何渲染色情暴力的内容，或侵犯或违反任何版权或商标或知识产权。中国移动香港保留删除相关内容及取消任何违反以上条款之参加者的参加/得奖资格及采取法律追究行动之权利，并不会就有关侵权行为负上任何责任。'
        ]
      },
      prize: {
        title: '奖项及奖品',
        list1: [
          '于活动期间完成10000步，即可获赠最多两份礼品，所有礼品均受其使用条款及细则约束。「$10电子缴费券2张」只适用于中国移动香港的服务计划客户；「$10电子增值券2张」只适用于中国移动香港的储值卡客户；「中银集团保险礼品包」适用于中国移动香港客户、MySim客户或非中国移动香港的客户。详情如下：'
        ],
        thead1: {
          label: '礼品',
          value: '合资格参加者'
        },
        table1: [
          {
            label: '$10电子缴费券2张',
            value: '中国移动香港的服务计划客户'
          },
          {
            label: '$10电子增值券2张',
            value: '中国移动香港的储值卡客户'
          },
          {
            label: '中银集团保险礼品包',
            value: '中国移动香港客户、MySim客户或非中国移动香港的客户'
          }
        ],
        list2: [
          '本活动所有的礼品视乎供应情况而定，换完即止。',
          '除特别注明外，本活动的礼品不可与其他优惠同时享用。',
          '本活动所有的礼品均不可退换或兑换现金，亦不能更换丶退款丶转让或转售。',
          '于投票时段内，获得最高票数的100名参加者将有机会获得指定智能手机一部；余下50名参加者将有机会获得指定背囊一个，详见下表：'
        ],
        thead2: {
          label: '票数排名',
          value: '奖品'
        },
        table2: [
          {
            label: '票数排名第一至第五名',
            value: 'iPhone XS (256GB)'
          },
          {
            label: '票数排名第六至第十名',
            value: 'Samsung Galaxy S9+ (256GB)'
          },
          {
            label: '票数排名第十一至第二十五名',
            value: 'iPhone 8 (256GB)'
          },
          {
            label: '票数排名第二十六至第三十名',
            value: 'HUAWEI Mate 20 Pro'
          },
          {
            label: '票数排名第三十一至第五十五名',
            value: 'HUAWEI P20'
          },
          {
            label: '票数排名第五十六至第八十名',
            value: 'Samsung Galaxy A8+'
          },
          {
            label: '票数排名第八十一至第一百名',
            value: 'iPhone SE (128GB)'
          },
          {
            label: '票数排名第一百零一名至第一百五十名',
            value: '「中移动香港行山节」指定背囊'
          },
        ],
        list3: [
          '如有相片于投票时段结束后获得相同票数，依据中国移动香港伺服器纪录，较先上载的相片会获较高排名。',
          '中国移动香港送出之奖品均不可兑换现金或其他货品/服务，亦不能更换、退款、转让及转售。',
          '18岁以上的得奖者须亲身或以书面形式授权另一名成年人领取奖品。18岁以下的得奖者必须由家长或监护人代为领奖，并须于领奖时提供家长/监护人同意书证明。',
          '奖品一经领取后，若有破坏、遗失或被窃，中国移动香港恕不补发。'
        ]
      },
      results: {
        title: '结果公布',
        list: [
          '所有奖项的得奖名单将于MyLink手机应用程式内公布。得奖名单将会公开的资料包括参加者姓名、相片、相片标题及参加者的首四位流动电话号码。得奖者将获专人以电话方式通知。中国移动香港将根据参加者登入MyLink手机应用程式的手机号码联络得奖者。各奖项公布日期如下：',
          '投票结果公布日期及途径：香港时间2019年1月7日中午12时在MyLink手机应用程式内公布',
          '如中国移动香港于香港时间2019年1月18日23:59之前仍无法联络得奖者，或得奖者或其授权人或其家长 /监护人于香港时间2019年2月1日23:59之前仍没有领取奖品，将被视作放弃论，其得奖资格将被取消。',
          '中国移动香港对供应商提供的商品或服务之品质、安全性及合法性，刊登内容之真实性及准确性，供应商的商誉与可信性均无控制力及保证。'
        ]
      },
      personal: {
        title: '个人资料收集声明',
        list: [
          '主办机构将会在参加者上载相片参加「万步有礼」活动时，收集参加者的个人资料，包括手提电话号码、年龄及姓名等。主办机构保障参加者所提供之一切资料。当参加者使用服务上载相片时，有关个人资料将会被收集、储存及使用以作核实。',
          '本声明乃遵照《个人资料(私稳)条例》(第486章)的要求而发出，通知您作为参加者收集资料的目的、您同意大会如何使用这些资料及您的权利。本声明会不时更改，故请定期查阅。参加者每次登记及/ 或使用我们的服务时，即表示同意接受当时生效之个人资料收集声明。',
          '参加者可能会被要求向主办机构提供个人识别资料。为让参加者可以参加「中移动香港行山节—万步有礼」，该些资料是必要的。倘若参加者未能提供所需资料，参加者将不能获得参赛资格。'
        ]
      },
      purpose: {
        title: '资料之目的及用途',
        list: {
          title: '大会所收集之资料将用作以下用途：',
          list: [
            '识别和核实参加活动的参加者的身份及/ 或资格',
            '就有关或因参加活动的事项与参加者沟通',
            '汇编参加者的整体统计资料，分析、评估及改进主办机构所提供的活动'
          ]
        }
      },
      transfer: {
        title: '资料之转移',
        list: [
          '参加者之个人资料将被保密。然而由于系统管理、运作及保养需要，主办机构会将有关资料转移或披露予对主办机构有保密责任并提供与主办机构运作有关行政、电讯、电脑系统服务、数据处理或其他服务的承办商。',
          '参加者有权根据《个人资料（私隐）条例》(第486章)的规定，要求查阅或更正参加者之个人资料。如有任何查阅或更正资料的要求，请向本公司资料保障主任提出，其办事处位于香港新界葵涌葵昌路51号九龙贸易中心1座20楼。主办机构的私隐政策声明可于其网页www.hk.chinamobile.com获取。',
          '参加者对于是次活动及评审的决定均不得异议。活动不设上诉机制。中国移动香港拥有修改及解释以上规则的权利。如有任何争议，中国移动香港保留最终决定权。',
          '本条款及细则受香港法律管辖。参加者同意任何因本条款及细则所引起的任何诉讼或索赔受香港法院的专属司法管辖权管辖。',
          '本条款与细则的中、英文本如有任何歧义，概以英文本为准。'
        ]
      }
    },
    couponList: {
      title: '中银集团保险礼品包',
      list: {
        travel: {
          img: 'static/xingshan/travel.jpg',
          title: '环宇遨翔旅游保障计划单次旅程68折/ 全年计划8折',
          time: '2018年12月16日至2019年2月10日(包括首尾两天)',
          code: 'CMHKHF',
          url: 'https://www5.bocgins.com/untrv/index.html?url=html/home/home.html&channel=BOCGI&product=1002&lang=TW'
        },
        home: {
          img: 'static/xingshan/home.jpg',
          title: '周全家居综合险8折',
          time: '2018年12月16日至2019年2月10日(包括首尾两天)',
          code: 'CMHKHF',
          url: 'https://www4.bocgins.com/zh-tw/website/online-apply-select/Home_Comprehensive/'
        },
        insurance: {
          img: 'static/xingshan/car.jpg',
          title: '汽车保险 - 私家车尊享特惠保费',
          time: '2018年12月16日至2019年2月10日(包括首尾两天)',
          code: 'CMHKHF',
          url: 'https://www4.bocgins.com/zh-tw/website/online-apply-select/Motor/'
        },
      }
    },
    coupon: {
      title: '详情',
      use: '去使用',
      codeTitle: '优惠码',
      copyTip1: '点击优惠码区域可复制优惠码',
      copyTip2: '优惠码已复制，可在优惠页面粘贴使用',
      copyTip3: '系统不支持复制优惠码，可长按粘贴使用',
      confirm: '确定',
      tips: '阁下将跳转至中银集团保险有限公司网站',
      activity: {
        explain: [
          {
            title: '推广条款及细则:',
            list: [
              '此推广不可与其他优惠同时使用(包括但不限于使用优惠编码)。',
              '此推广不能兑换现金或同等价值之物品。',
            ]
          },
          {
            title: '一般条款及细则：',
            list: ['本计划由中银集团保险有限公司 (「中银集团保险」)承保。',
              '中银集团保险已获保险业监管局授权在中华人民共和国香港特别行政区经营一般保险业务，并受其监管。',
              '中银集团保险保留根据投保人及/或受保人于投保时所提供的资料，而决定是否接受任何有关本计划投保申请的绝对权利。',
              '中银集团保险保留随时修订丶暂停或取消本计划丶服务与优惠以及修订有关条款的酌情权而毋须事先通知。',
              '本计划各项条款及细则以中银集团保险缮发的正式保单为准。各项保障项目及承保范围丶条款及不承保事项，请参阅保单。',
              '本宣传品仅供参考，宣传品只在香港派发，不能诠释为在香港境外提供或出售或游说购买中银集团保险的任何产品的要约丶招揽及建议。',
              '如本宣传品的中丶英文版本有任何歧异，概以英文版本为准。',
              '详情请于办公时间致电中银集团保险客户查询热线：(852) 3187 5100。']
          },
          {
            title: '中国移动香港条款与细则：',
            list: [
              '本活动所有优惠/礼品图片及描述仅供参考，均以实物为准。',
              '任何因电脑丶网路等技术问题而引致客户所递交的资料有迟延丶遗失丶错误丶无法辨识等情况，中国移动香港概不负责。',
              '任何因合资格客户参加本活动而引致之任何损失丶伤害丶费用丶索赔丶诉讼 (包括但不限于直接丶间接及后果性损失)，中国移动香港概不负责。',
              '此优惠所涉及之产品丶服务及资讯均由中银集团保险有限公司（「供应商」）直接提供给合资格用户，所有有关责任及义务由全权负责。',
              '中国移动香港对供应商于此优惠提供的商品或服务之品质丶安全性及合法性，刊登内容之真实性及准确性，供应商的商誉与可信性，供应商实际出售商品或服务之能力均无控制力及保证。',
              '凡领取此优惠的用户，即表示已细阅并同意此条款及细则及个别优惠的条款及细则。如有任何违反此等条款及细则丶以不诚实手法参加或进行本活动及/或造假者，中国移动香港有权立即取消其享用此优惠的资格，而不作任何通知，并对任何违反行为保留追究权利。',
              '合资格客户在本活动中所提供的个人资料，如姓名丶手提电话号码及电邮地址等，只会用作本活动联络客户及领奖时核实身份的用途。中国移动香港会将有关个人资料保存及保密处理，并于领奖完结后2个月内销毁。中国移动香港不会使用有关个人资料作为日后直接促销的用途。如客户欲查阅个人资料及更正个人资料或询问个人资料有关声明，请致函: 中国移动香港有限公司，地址：香港新界葵涌葵昌路51号九龙贸易中心1座20楼，收信人：资料保护主任或致电中国移动香港拒收商业电子讯息登记热线62264926或客户服务热线2945 8888。',
              '如中国移动香港怀疑合资格客户有 （i）进行或与异常/可疑活动有关丶（ii）使用不当的方法或欺诈行为而使本活动任何部份运作中断或受到干扰，导致技术问题，或检测到（iii）任何不诚实的行为丶提供虚假或不正确的资料或（iv）任何违反本条款及细则或其他任何适用法律或条文；中国移动香港有权在不作任何通知及毋须对任何人士负上任何责任的情况下自行决定取消其资格，并对该人士保留追究权利。',
              '若因延误或未有履行本条款及细则或当中任何部分，且原因在中国移动香港合理控制范围之外，或并非因为中国移动香港的过失或疏忽所致，而是因为战争丶有即将发生战争之威胁丶暴动丶民众骚动丶叛乱丶天灾丶政府或其他超国家法律机关实施限制丶其他劳资纠纷丶火灾丶爆炸丶暴风雨丶水灾丶雷击丶地震和其他自然灾害等等所致，中国移动香港即不必对由此引起的任何损失和损害负责。',
              '除各供应商外，其他人士均无权根据《合约（第三者权利）条例》（香港法例第623 章）及适用于中国移动香港的其他规章强制执行本条款及细则，也无权享有本协议及适用于中国移动香港的其他规章所给予的任何利益。',
              '本条款及细则受香港法律管辖。合资格用户同意任何因本条款及细则所引起的任何诉讼或索赔受香港法院的专属司法管辖权管辖。',
              '中国移动香港或中银集团保险有限公司随时更改本优惠内容丶终止此优惠丶修订此条款及细则的权利，而恕不另行通知。'
            ]
          },
        ]
      }
    },
    photoPedding: {
      photoDetail: {
        title: '「万步有礼」活动',
        h1: '「万步有礼」活动',
        time: [['2018.12.24 ', '入围作品公布'], ['2018.12.24-30', '作品公众投票'], ['2019.1.7(中午12:00)', '投票结果公布']],
        p: ['大会鼓励全民运动，特意举办「万步有礼」活动。',
          '全港市民只要在12月16日当日开启MyLink手机应用程序，透过WeWalk页面内的计步功能并步行够一万步，即可在MyLink上载一张行山香港照片。',
          '大会将会精选150张最精彩的相片，并由公众投票，获得最多票数的头100位参赛者将有机会获智能手机一部！'],
        btn: '敬请留意入围作品结果！',
        agency:['电话：2127 4720（星期一至至早早10时至晚上7时）','电邮：wewalk.enquiry@gmail.com']
      },
      nullPhoto: {
        title: '查询结果',
        sorry: '抱歉！',
        tips: '未查询到阁下参与活动的纪录'
      },
      photo: {
        title: '查询结果',
        h1: '阁下参与「万步有礼」摄影活动的资料如下：',
        name: '姓名：',
        phone: '手机号码：',
        tips: '活动相片正在评审中，密切留意！'
      }
    },
    photoVote:{
      title1:'万步有礼 送出100部智能手机',
      title2:'活动投票',
      title3:'投票结果',
      btn1:'去查看',
      btn2:'返回活动页',
      btn3:'提交',
      btn4:'否',
      btn6:'是',
      btn5:'参与投票',
      votePhoto:'入围作品',
      noData:'无数据',
      share:{
        index:['「万步有礼」相片投票','投票结果'],
        myPhoto:['「万步有礼」相片投票','我正在投选「万步有礼」最能代表香港的相片，入围作品编号','快來幫我投票吧'],
        list:['活动投票','「万步有礼」相片投票']
      },
      end:['「万步有礼」活动投票阶段已经结束，结果将于','2019年1月7日','公布，敬请留意！'],
      voted:{
        title:['感谢阁下投票！','多谢你的支持！'],
        label:['投票作品:','阁下投票资料为：'],
        item:['编号:','票数:']
      },
      nuPicked:['阁下参与「万步有礼」摄影活动的资料如下：','抱歉！阁下的相片未能入围。',' 150张入围相片投票阶段已经展开，立即投选你的心水相片！'],
      picked:['阁下参与「万步有礼」摄影活动的资料如下：','阁下的作品已获选为150张最精彩的相片，投票阶段已经展开，有机会赢取智能手机一部！立即投选你的心水相片！','入围作品编号:'],
      voteError:['阁下投票失败！','请稍后再试'],
      voteList:{
        inputplaceholder:'请输入相片编号',
        vote:['投票','已投','票','可投'],
        tips:['提示','阁下可投选5票。一经提交后，不能修改。是否继续提交？'],
        rules:[{
          title:'万步有礼 送出100部智能手机',
          list:['大会鼓励全民运动，特意举办「万步有礼」活动。',['全港市民只要在','12月16日','当日开启MyLink手机应用程序，透过WeWalk页面内的计步功能并步行够一万步，即可在MyLink上载一张行山香港照片。'],'大会将会精选150张最精彩的相片，并由公众投票，获得最多票数的头100位参赛者将有机会获智能手机一部！']
        },{
          title:'活动投票规则',
          label:['投票时间：',' 12月24日00:00 - 12月30日23:59'],
          list:[' 只限MyLink登录用户投票，每位用户只可投选每张照片1次。','每位MyLink登录用户最多可投选5张相片。']
        }]
      }
    },
    photoResult:{
      title1:'「万步有礼」活动',
      title2:'结果公布',
      title3:'下载获奖相片',
      btn1:'结果公布',
      normal:['「万步有礼」 送出100部智能手机'],
      sorry:'抱歉，閣下未中獎，謝謝關注本次行山節活動，歡迎下次參與！',
      win:['恭喜您！阁下可于2019年1月11日（星期五）起至2月1日或之前亲自或委托他人到大会秘书处领奖。详情请联络秘书处。',
        '电话：(852) 2127 4720',
        '电邮：wewalk.enquiry@gmail.com',
        '地址：新界葵涌葵昌路50号葵昌中心6楼12室'
      ],
      listTitle:'获奖结果',
      prize:['第','名'],
      share:{
        title:'「万步有礼」活动结果公布！',
        content:'中移动香港行山节「万步有礼」活动'
      },
      end:'留意万步有礼得奖结果',
      save:'长按相片可储存相片到相册'
    }
  },
  ...newYear,
  ...activity
}



// WEBPACK FOOTER //
// ./src/locale/zh-cn.js